export default "__VITE_ASSET__B6jtUU3d__"